import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { Button } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { Platform, View } from 'react-native';
import { Position } from '@/contexts/toast-context';
import { TimePickerInput } from './time-picker-input.web';
import { TimePickerModalProps } from './types';

export const TimePickerModal: React.FC<TimePickerModalProps> = ({
  accessibilityLabel,
  date,
  onConfirm,
  onCancel,
  minimumDate,
  minuteInterval = 1,
  confirmButtonTestID,
  cancelButtonTestID,
}) => {
  const [styles] = useStyles();
  const [selectedTime, setSelectedTime] = useState(date);

  if (Platform.OS !== 'web') {
    return null;
  }

  const handleConfirm = () => {
    if (!selectedTime) {
      return;
    }
    // Ensure the selected time is a valid Date object
    onConfirm(selectedTime);
  };

  return (
    <BaseActionSheet
      accessibilityLabel={accessibilityLabel}
      isVisible
      onClose={onCancel}
      toastPosition={Position.TOP}
    >
      <TimePickerInput
        date={selectedTime}
        minimumDate={minimumDate}
        minuteInterval={minuteInterval}
        onChange={setSelectedTime}
        trackingData={null}
      />

      <View style={[styles.row, styles.popoverActions]}>
        <Button
          onPress={onCancel}
          size="small"
          style={styles.popoverActionButton}
          testID={cancelButtonTestID}
          trackingData={{
            name: 'time_picker_web_modal.cancel',
          }}
          type="tertiary"
        >
          {i18n.t('cancel')}
        </Button>
        <Button
          disabled={!selectedTime}
          onPress={handleConfirm}
          size="small"
          style={styles.popoverActionButton}
          testID={confirmButtonTestID}
          trackingData={{
            name: 'time_picker_web_modal.save',
            properties: {
              time: selectedTime?.toISOString(),
            },
          }}
          type="primary"
        >
          {i18n.t('save')}
        </Button>
      </View>
    </BaseActionSheet>
  );
};

const useStyles = createStyles(() => ({
  popoverActionButton: {
    paddingHorizontal: 32,
  },
  popoverActions: {
    gap: 8,
    justifyContent: 'flex-end',
    marginTop: 16,
  },
  row: {
    flexDirection: 'row',
  },
}));
